import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-none text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#C4A084] text-white shadow hover:bg-[#B8956F]",
        destructive:
          "bg-[#FFEBEE] text-[#E57373] shadow-sm hover:bg-[#FFCDD2]",
        outline:
          "border border-[#C4A084] bg-white text-[#5D4E3C] shadow-sm hover:bg-[#F5EDE4]",
        secondary:
          "bg-[#F5EDE4] text-[#5D4E3C] shadow-sm hover:bg-[#EBE0D4]",
        ghost: "hover:bg-[#F5EDE4] hover:text-[#5D4E3C]",
        link: "text-[#C4A084] underline-offset-4 hover:underline",
        // Admin pastel variants
        success: "bg-[#E8F5E9] text-[#4CAF50] hover:bg-[#C8E6C9]",
        warning: "bg-[#FFF3E0] text-[#FF9800] hover:bg-[#FFE0B2]",
        info: "bg-[#E3F2FD] text-[#2196F3] hover:bg-[#BBDEFB]",
        purple: "bg-[#F3E5F5] text-[#9C27B0] hover:bg-[#E1BEE7]",
        pink: "bg-[#FCE4EC] text-[#E91E63] hover:bg-[#F8BBD9]",
      },
      size: {
        default: "h-9 px-4 py-2 min-h-[36px]",
        sm: "h-8 px-3 text-xs min-h-[32px]",
        lg: "h-10 px-8 min-h-[40px]",
        icon: "h-9 w-9 min-h-[36px] min-w-[36px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
